export const HELP_APP_URL = "https://ecomtrack.ladesk.com/";
export const AFFILIATES_APP_REGISTER_URL = "https://affiliates.ecomtrack.io/signup";
export const AFFILIATES_APP_LOGIN_URL = "https://affiliates.ecomtrack.io/login";
export const PRICING_URL = "https://ecomtrack.io/pricing";
export const CONTACT_APP_URL = "https://ecomtrack.io/contact/";
export const CURRENCY_LIST_URL = "https://stripe.com/docs/currencies";
